import { useMemo } from 'react'

import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { Nationalities } from '../../../utils/constants'
import EntitiesSelector from './EntitiesSelector'

const NationalitiesSelector = ({ className = '', disabled, multiple = 'default', style = {}, values, onChange }) => {
  const t = useSelector(selectTranslate)

  const nationalitiesOptions = useMemo(() => Object.values(Nationalities).map(label => ({
    label: t('nationalities.' + label.toLowerCase()),
    value: label
  })), [t])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={nationalitiesOptions}
      multiple={multiple}
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default NationalitiesSelector
